import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import { TargetingSettingsContext } from '../targeting-settings-context';

export default class ColumnCampaignType extends CampaignuiBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'CampaignType',
      property: 'Campaign/CampaignType',
      sortable: 'Campaign/CampaignType',
      title: 'ColumnName_CampaignType',
      i18n,
    });
  }

  get property() {
    return {
      get: ({ Campaign }) => {
        if (Campaign) {
          return TargetingSettingsContext.i18n.getString(`CampaignType_${Campaign.CampaignType}`);
        }

        return '';
      },
      key: this.config.property,
    };
  }
}
